import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeEnergy2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeEnergy2"><Path d="M12.0007 1.77014L22.8959 9.57021L21.7317 11.1964L20.0007 9.95717V21H15.0007V19H18.0007V8.52534L12.0007 4.22985L6.0007 8.52534V19H9.00069V21H4.0007V9.95717L2.2697 11.1964L1.10547 9.57021L12.0007 1.77014Z" fill="currentColor"/><Path d="M13.0007 11H11.0007V9H9.00069V11H8.00069V17H11.0007V21H13.0007V17H16.0007V11H15.0007V9H13.0007V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeEnergy2;
